import { APP_MANAGED_ROUTES } from '@highmark-web/highmark-common';
import { LEAGUE_MODULE_NAMES, overwriteRoutePaths } from '@leagueplatform/core';

overwriteRoutePaths({
  [LEAGUE_MODULE_NAMES.wallet]: '/benefits',
  [LEAGUE_MODULE_NAMES.careDiscovery]: '/care-discovery',
  [LEAGUE_MODULE_NAMES.liveChat]: APP_MANAGED_ROUTES.LIVE_CHAT,
  [LEAGUE_MODULE_NAMES.messaging]: APP_MANAGED_ROUTES.MESSAGING,
});
